// Las teclas del chat abierto: Esc lo cierra (si no estás escribiendo). Alt+↓/↑ salta al siguiente/anterior QUE TE
// NECESITA en el orden de la lista (04-11, auditoría de flujo: 64 % de los mensajes de Pau cambian de agente y antes
// Alt+↓ pasaba también por los que trabajan solos); Alt+Mayús+↓/↑ recorre a todos. Cuando no queda nadie, lo dice.
// El orden es el de useEquipo: el mismo que se ve en la lista (misma bandeja, mismos grupos, con «Con Santi»).
import { useEffect } from 'react';
import { t } from '../../../i18n';
import { useToastStore } from '../../../stores/toast.store';
import type { ContratadoDTO } from '../compartido/vocabulario';
import { siguienteEnEquipo, useEquipo } from '../marco/useEquipo';
import { useOficinaStore } from '../store';

export function useTeclasChat({ agentId, contratados, alCambiar, alCerrar }: { agentId: string; contratados: Record<string, ContratadoDTO>; alCambiar: (agentId: string) => void; alCerrar: () => void }): void {
  const { orden, necesita } = useEquipo(contratados);
  useEffect(() => {
    const alTeclear = (e: KeyboardEvent) => {
      // Con una ventana (contratar, plan, cerrar) encima, sus teclas son suyas.
      if (useOficinaStore.getState().contratarAbierto || document.querySelector('[role="dialog"]')) return;
      const destino = e.target as HTMLElement | null;
      const escribiendo = !!destino && (destino.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(destino.tagName));
      const vacio = !escribiendo || !(destino as HTMLInputElement).value;
      if (e.key === 'Escape' && !e.defaultPrevented && vacio) alCerrar();
      if (e.altKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        e.preventDefault();
        const sig = siguienteEnEquipo(orden, agentId, e.key === 'ArrowDown' ? 1 : -1, e.shiftKey ? () => true : necesita);
        if (sig) alCambiar(sig.agentId);
        else useToastStore.getState().push({ message: t('oficinaV2.equipo.nadaMasTeToca'), durationMs: 2_500 });
      }
    };
    window.addEventListener('keydown', alTeclear);
    return () => window.removeEventListener('keydown', alTeclear);
  }, [agentId, alCambiar, alCerrar, orden, necesita]);
}
